(function () {
    'use strict';

    // @ngInject
    function WorkflowSetUpControllerCtor($scope, $injector, AnalyticsService, $stateParams, _, $translate, CompaniesManager, AppStates, PopupMessageService,
                                         WorkflowService, WorkflowManager) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'WorkflowSetUpController';
        AnalyticsService.trackPageView(this, 'WorkflowSetUpView');
        this.FILE_TEMPLATE_ID = "file_template_id";
        this.EMAIL_TEMPLATE_ID = "email_template_id";

        this.$translate = $translate;
        this.CompaniesManager = CompaniesManager;
        this.WorkflowService = WorkflowService;
        this.WorkflowManager = WorkflowManager;
        this.AppStates = AppStates;
        this.PopupMessageService = PopupMessageService;
        this._ = _;

        this.company = this.CompaniesManager.getCurrCompany();

        this.companyEmailTemplates = this.setDropdownList(this.company.vendor_emails);
        this.getQuestionnairesTemplates = this.company.questionnaires;
        this.getBrochureTemplates = this.company.getCompanyBrochures(true);

        this.workflowModel = null;
        this.workflowViewModel = null;
        this.fetchingWorkflow = true;
        this.workflowStepsOrder = [];

        this.WorkflowManager.getWorkflowTemplate(this.company, $stateParams.workflow_id)
            .then(function success(resp) {
                this.workflowModel = resp.data;
                this.buildViewModel(this.workflowModel);
            }.bind(this))
            .catch(function fail(resp) {
            }.bind(this))
            .finally(function finallyHandler() {
                this.fetchingWorkflow = false;
            }.bind(this));

        //init
        this.addWorkflowStep = true;
        this.prepareEnums();

        $scope.$on('$destroy', function () {
            this.WorkflowService.onExitTemplateWorkflowSetup();
        }.bind(this));

    }

    Controllers.WorkflowSetUpController = Class(Controllers.BaseController, {
        constructor: WorkflowSetUpControllerCtor,

        buildViewModel: function buildViewModel(workflowModel) {
            this.workflowViewModel = angular.copy(workflowModel);
            this.WorkflowService.currentWorkflowViewModel = this.workflowViewModel;
            if (this.workflowViewModel.workflow_steps) {
                this.workflowViewModel.workflow_steps.forEach(function stepsIter(stepModel) {
                    //create a unique client side id
                    this.extendStepViewModel(stepModel);
                    stepModel.isEditMode = false;
                }.bind(this));
            } else {
                this.workflowViewModel.workflow_steps = [];
            }
            this.sortedStepsOrder(false);
            this.initDraggableStep();

        },

        initDraggableStep: function initDrag(){
            var self = this;

            this.workflowSortableOptions = {
                revert: 200,
                axis: 'y',
                handle: ' .drag-icon-container',

                stop: function stop(event, ui) {
                  self.sortedStepsOrder(true);
                }
            };
        },

        reassignStepsOrder: function reasignStepsOrder(workflowViewModel) {
            var currentStepViewModel;
            if (workflowViewModel && workflowViewModel.workflow_steps && workflowViewModel.workflow_steps.length) {
                for(var i = 0, length = workflowViewModel.workflow_steps.length; i < length; i++){
                    currentStepViewModel = workflowViewModel.workflow_steps[i];
                    currentStepViewModel.order = i;
                }
            }
        },

        sortedStepsOrder: function sortedStepsOrder(setDirty) {
            if (setDirty) {
                this.WorkflowService.setWorkflowViewModelAsDirty();
            }

            this.reassignStepsOrder(this.workflowViewModel);
            this.workflowStepsOrder = this.workflowViewModel.workflow_steps;

            this.WorkflowService.currentWorkflowViewModel = this.sortedWorkflowSteps(this.workflowViewModel);
        },

        sortedWorkflowSteps: function sortedWorkflowSteps(workflowObj) {
          workflowObj.workflow_steps.sort(function (a, b) {
              return a.order - b.order;
          });
          return workflowObj;
        },

        extendStepViewModel: function extendStepActionViewModel(stepViewModel) {
            var stepAction = stepViewModel.workflow_step_action;
            var stepTrigger = stepViewModel.workflow_step_trigger;

            stepViewModel.beforeStepActionChange = function beforeStepActionChange(item) {
                if (!this.isAvailableToCreate(item.key)) {
                    this.unableToCreateStepPopup(item.key);
                    return false;
                }

                return true;
            }.bind(this);

            stepViewModel.onStepActionChanged = function onStepActionChanged(item) {
                this.WorkflowService.setWorkflowViewModelAsDirty();

                return this.onSelectStepActionType(stepViewModel, item);
            }.bind(this);

                //find the right value for the drop down
            stepViewModel.selectedApprovalMethod = this._.findWhere(this.WorkflowService.workflowApprovalEnum, {key: stepViewModel.approval_status});
            stepViewModel.onSelectedApprovalMethod = function onSelectedApprovalMethod(item) {
                this.WorkflowService.setWorkflowViewModelAsDirty();
                return this.onSelectedApprovalMethod(stepViewModel, item);
            }.bind(this);

            stepTrigger.selectedWorkflowTrigger = this._.findWhere(this.WorkflowService.workflowTriggersEnum, {key: stepTrigger.trigger_type});
            stepTrigger.onSelectedWorkflowTriggerSelected = function onSelectedWorkflowTriggerSelected(item) {
                this.onSelectedWorkflowTriggerSelected(stepTrigger, item);
            }.bind(this);

            stepViewModel.isEditMode = true;

            switch (stepViewModel.workflow_step_action.type) {
                case 'task':
                    this.extendTaskAction(stepAction);
                    break;
                case 'file':
                    switch(stepAction.file_type){
                        case 'questionnaire':
                            this.extendQuestionnaireAction(stepAction);
                            break;
                        case 'brochure':
                            this.extendBrochureAction(stepAction);
                            break;
                    }
                   break;
                case 'email':
                    this.extendEmailAction(stepAction);
                    break;
            }
        },

        createWorkflowStep: function createWorkflowStep(uiActionType) {

            if (this.fetchingWorkflow) {
                return;
            }

            if (!this.isAvailableToCreate(uiActionType)) {
                this.unableToCreateStepPopup(uiActionType);
                return;
            }

            this.WorkflowService.setWorkflowViewModelAsDirty();

            this.changeAllWorkflowStepsState(false);

            var stepViewModel = {
                approval_status: this.WorkflowService.workflowApprovalEnum[0].key,
                workflow_step_action: {
                    type: null,
                },
                workflow_step_trigger: {
                    trigger_type: this.WorkflowService.workflowTriggersEnum[0].key,
                    days_to_trigger: 0
                }
            };

            this.setTypeOnViewModel(stepViewModel, uiActionType);

            this.extendStepViewModel(stepViewModel);

            this.workflowViewModel.workflow_steps.push(stepViewModel);
            this.reassignStepsOrder(this.workflowViewModel);
            this.addWorkflowStep = false;
        },

        setTypeOnViewModel: function setTypeOnViewModel(stepViewModel, uiActionType) {
            //set the right type on it
            if (uiActionType === 'brochure' || uiActionType === 'questionnaire') {
                stepViewModel.workflow_step_action.type = 'file';
                stepViewModel.workflow_step_action.file_type = uiActionType;
            } else {
                stepViewModel.workflow_step_action.type = uiActionType;
            }
        },

        onSelectStepActionType: function selectWorkflowType(stepViewModel, item) {
            var uiActionType = item.key;
            //create a new empty action view model for the newly chosen action
            stepViewModel.workflow_step_action = {
                type: null,
            };

            this.setTypeOnViewModel(stepViewModel, uiActionType);

            // extend it with the right properties
            this.extendStepViewModel(stepViewModel);
        },

        onTemplateSelected: function onTemplateSelected(workflowStepAction, item, propertyToUpdate) {
            this.WorkflowService.setWorkflowViewModelAsDirty();
            workflowStepAction.selectedTemplate = item;
            workflowStepAction[propertyToUpdate] = item.key;
        },

        onNumberOfDaysChanged: function onNumberOfDaysChanged() {
            this.WorkflowService.setWorkflowViewModelAsDirty();
        },

        //this function will be used to extend each action and invoked with the right step-trigger as the context placed in 'this'
        onSelectedWorkflowTriggerSelected : function onSelectedWorkflowTriggerSelected(stepTrigger, item) {
            this.WorkflowService.setWorkflowViewModelAsDirty();

            stepTrigger.selectedWorkflowTrigger = item;
            stepTrigger.trigger_type = item.key;
        },

        onSelectedApprovalMethod: function onSelectedApprovalMethod(stepViewModel, item) {
            this.WorkflowService.setWorkflowViewModelAsDirty();

            stepViewModel.selectedApprovalMethod = item;
            stepViewModel.approval_status = item.key;
        },

        onEmailTemplateSelected: function onEmailTemplateSelected(workflowStepAction, item) {
            this.WorkflowService.setWorkflowViewModelAsDirty();

            workflowStepAction.selectedEmailTemplate = item;
            workflowStepAction.email_template_id = item.key;
        },

        extendTaskAction: function addTaskAction(workflowStepAction) {
            workflowStepAction.selectedActionType = this.WorkflowService.workflowStepActionTypesEnum[0];
            workflowStepAction.templateListLabel = 'need value';
            workflowStepAction.emailTemplateList = this.setDropdownList(this.companyEmailTemplates);
        },

        extendQuestionnaireAction: function addQuestionnaireAction(workflowStepAction) {
            workflowStepAction.selectedActionType = this.WorkflowService.workflowStepActionTypesEnum[1];

            workflowStepAction.templateList = this.setDropdownList(this.getQuestionnairesTemplates);
            if(!workflowStepAction.file_template_id){
                workflowStepAction.selectedTemplate = workflowStepAction.templateList[0];
                workflowStepAction.file_template_id = workflowStepAction.selectedTemplate.key;
            } else {
                workflowStepAction.selectedTemplate = this._.findWhere(workflowStepAction.templateList, {key: workflowStepAction.file_template_id});
            }
            workflowStepAction.onTemplateSelected = function onTemplateSelected(item) {
                this.onTemplateSelected(workflowStepAction, item, this.FILE_TEMPLATE_ID);
            }.bind(this);

            if(!workflowStepAction.email_template_id){
                workflowStepAction.selectedEmailTemplate = this.companyEmailTemplates[0];
                workflowStepAction.email_template_id = workflowStepAction.selectedEmailTemplate.key;
            } else {
                //TODO: check if we could not find the template (user may have deleted it)
                workflowStepAction.selectedEmailTemplate = this._.findWhere(this.companyEmailTemplates, {key: workflowStepAction.email_template_id});
            }
            workflowStepAction.onEmailTemplateSelected = function onEmailTemplateSelected(item) {
                this.onEmailTemplateSelected(workflowStepAction, item);
            }.bind(this);

        },

        extendEmailAction: function addEmailAction(workflowStepAction) {
            workflowStepAction.selectedActionType = this.WorkflowService.workflowStepActionTypesEnum[2];

            workflowStepAction.templateList = this.companyEmailTemplates;
            if(!workflowStepAction.email_template_id){
                workflowStepAction.selectedTemplate = workflowStepAction.templateList[0];
                workflowStepAction.email_template_id = workflowStepAction.selectedTemplate.key; //which is the id of the template
            } else {
                workflowStepAction.selectedTemplate = this._.findWhere(workflowStepAction.templateList, {key: workflowStepAction.email_template_id});
            }

            workflowStepAction.onTemplateSelected = function onTemplateSelected(item) {
                this.onTemplateSelected(workflowStepAction, item, this.EMAIL_TEMPLATE_ID);
            }.bind(this);

            //here we dont have the selectedEmailTemplate cause the main templates (next to the action) is the template for this kind of step
        },

        extendBrochureAction: function addBrochureAction(workflowStepAction) {
            workflowStepAction.selectedActionType = this.WorkflowService.workflowStepActionTypesEnum[3];

            workflowStepAction.templateList = this.setDropdownList(this.getBrochureTemplates);
            if(!workflowStepAction.file_template_id){
                workflowStepAction.selectedTemplate = workflowStepAction.templateList[0];
                workflowStepAction.file_template_id = workflowStepAction.selectedTemplate.key; //which is the id of the template
            } else {
                workflowStepAction.selectedTemplate = this._.findWhere(workflowStepAction.templateList, {key: workflowStepAction.file_template_id});
            }

            workflowStepAction.onTemplateSelected = function onTemplateSelected(item) {
                this.onTemplateSelected(workflowStepAction, item, this.FILE_TEMPLATE_ID);
            }.bind(this);


            if (!workflowStepAction.email_template_id) {
                workflowStepAction.selectedEmailTemplate = this.companyEmailTemplates[0];
                workflowStepAction.email_template_id = workflowStepAction.selectedEmailTemplate.key;
            } else {
                //TODO: check if we could not find the template (user may have deleted it)
                workflowStepAction.selectedEmailTemplate = this._.findWhere(this.companyEmailTemplates, {key: workflowStepAction.email_template_id});
            }
            workflowStepAction.onEmailTemplateSelected = function onEmailTemplateSelected(item) {
                this.onEmailTemplateSelected(workflowStepAction, item);
            }.bind(this);

            //TODO: check if we need this.
            // workflowStepAction.sendWithThisEmail = this.findDefaultEmailTemplate('Brochure (default)');
        },

        enforceValidNumberOfDays: function enforceValidNumberOfDays(workflowStepViewModel) {
            var stepTrigger = workflowStepViewModel.workflow_step_trigger;
            if (!stepTrigger.days_to_trigger){
                stepTrigger.days_to_trigger = 0;
            }
        },

        showWorkflowStep: function showWorkflowStep(){
            this.addWorkflowStep = !this.addWorkflowStep;
        },

        deleteWorkflowStep: function deleteWorkflowStep(workflowStepViewModel){
            var indexToRemove = this._.findIndex(this.workflowViewModel.workflow_steps, workflowStepViewModel);
            if(indexToRemove !== -1){
                this.workflowViewModel.workflow_steps.splice(indexToRemove, 1);
                this.WorkflowService.setWorkflowViewModelAsDirty();
                this.reassignStepsOrder(this.workflowViewModel);
            }
        },

        editWorkflowStep: function editWorkflowStep (workflowStepViewModel) {
            if (!workflowStepViewModel.isEditMode) {
                this.changeAllWorkflowStepsState(false);
            }
            workflowStepViewModel.isEditMode = !workflowStepViewModel.isEditMode;
        },

        getStepSubtitle: function getStepSubtitle(wfvmStep) {

            // special handle for task
            if (wfvmStep.selectedActionType.key === 'task') {
              return wfvmStep.task_title;
            }

            return wfvmStep.selectedTemplate ? wfvmStep.selectedTemplate.text : 'Select template';
        },

        //TODO: check is we need this.
        findDefaultEmailTemplate: function findDefaultEmailTemplate(defaultEmailTemplate) {
            this.companyEmailTemplates.filter(function(emailTemplate){
                if (emailTemplate.title === defaultEmailTemplate) {
                    return emailTemplate;
                }
            });
        },

        //TODO: this could be refactored to be just one collection on this controller instead for each step
        setDropdownList: function setDropdownList(templates) {
            var templateCollection = [];

            templates.forEach(function(template){
                if (template._id) {
                    templateCollection.push({key: template._id, text: template.title, isFileAttached: angular.isFunction(template.hasAttachments) && template.hasAttachments(), attachmentsCount: angular.isFunction(template.countAttachments) && template.countAttachments()});
                }
            });

            return this._.sortBy(templateCollection, 'text');
        },

        changeAllWorkflowStepsState: function changeAllWorkflowStepsState(isEdit, stepToIgnore) {
            this.workflowViewModel.workflow_steps.forEach(function(step) {
                if(!stepToIgnore || stepToIgnore._id !== step._id) {
                    step.isEditMode = !!isEdit;
                }
            });
        },

        getStepAttachmentTitle: function getStepAttachmentTitle(count) {
            var stringToTranslate = 'WORKFLOW.TOOLTIPS._WORKFLOW_FILE_ATTACHED_';
            if (count > 1) {
                stringToTranslate = 'WORKFLOW.TOOLTIPS._WORKFLOW_FILE_ATTACHED_PLURAL_';
            }
            return this.$translate.instant(stringToTranslate);
        },

        isAvailableToCreate: function isAvailableToCreate(actionType) {
            if (actionType === 'questionnaire') {
                return this.getQuestionnairesTemplates.length > 0;
            }
            else if (actionType === 'brochure') {
                return this.getBrochureTemplates.length > 0;
            }

            return true;
        },

        unableToCreateStepPopup: function unableToCreateStepPopup(type) {
            this.PopupMessageService.showConfirmPromise(
                this.PopupMessageService.severityTypes.info,
                {translationId: 'WORKSPACE.WORKFLOW.POPUPS._NO_TEMPLATES_AVAILABLE_', interpolateParams: {templateType: type}},
                'WORKSPACE.WORKFLOW.POPUPS._CREATE_TEMPLATE_')
                .then(function confirm() {
                    return this.WorkflowService.onSaveWorkflow().catch(function failed(resp) {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                    }.bind(this));
                }.bind(this))
                .then(function saved() {
                    this.goToState(this.AppStates.root_core_navigation_templates);
                }.bind(this));
        },

        prepareEnums: function prepareEnums() {

            // action types
            this.workflowStepActionTypesEnum = this.WorkflowService.translateEnum(this.WorkflowService.workflowStepActionTypesEnum);

            // trigger types
            this.workflowTriggersEnum = this.WorkflowService.translateEnum(this.WorkflowService.workflowTriggersEnum);

            // approval types
            this.workflowApprovalEnum = this.WorkflowService.translateEnum(this.WorkflowService.workflowApprovalEnum);
        },


    });
}());

